import * as React from 'react';
import { createSubcomponent } from '@workday/canvas-kit-react/common';
import { SecondaryButton } from '@workday/canvas-kit-react/button';
import { usePopupCloseButton, usePopupModel } from './hooks';
export const PopupCloseButton = createSubcomponent(SecondaryButton)({
    displayName: 'Popup.CloseButton',
    modelHook: usePopupModel,
    elemPropsHook: usePopupCloseButton,
})(({ children, ...elemProps }, Element) => {
    return (React.createElement(Element, Object.assign({ type: "button" }, elemProps), children));
});
